import { useQuery, useQueryClient } from "react-query";
import axios from "axios";

const fetchDashboard = () => {
  return axios.get(`https://server.anshfintech.com/api/user/data/dashboard`);
};

const fetchLiveTradeData = () => {
  return axios.get(
    `https://server.anshfintech.com/api/common/live/live-trade`
  );
};

const fetchNewsFeedData = () => {
  return axios.get(`https://server.anshfintech.com/api/news-feed`);
};

const fetchTickerListData = () => {
  return axios.get(
    `https://server.anshfintech.com/api/user/data/ticker-list-data`
  );
};

export const UseDashboarddata = (heroId) => {
  const queryClient = useQueryClient();
  return useQuery(["user-hero", heroId], fetchDashboard, {
    initialData: () => {
      const data = queryClient
        .getQueryData("user-heroes")
        ?.data?.find((data) => data.id === parseInt(heroId));
      if (data) {
        return { data: data };
      } else {
        return undefined;
      }
    },
  });
};

export const UseLiveTradeData = (heroId) => {
  const queryClient = useQueryClient();
  return useQuery(["liveTrade", heroId], fetchLiveTradeData, {
    initialData: () => {
      const data = queryClient
        .getQueryData("liveTrade")
        ?.data?.find((data) => data.id === parseInt(heroId));
      if (data) {
        return { data: data };
      } else {
        return undefined;
      }
    },
  });
};

export const UseNewsFeedData = (heroId) => {
  const queryClient = useQueryClient();
  return useQuery(["newsFeed", heroId], fetchNewsFeedData, {
    initialData: () => {
      const data = queryClient
        .getQueryData("newsFeed")
        ?.data?.find((data) => data.id === parseInt(heroId));
      if (data) {
        return { data: data };
      } else {
        return undefined;
      }
    },
  });
};

export const UseTickerTistData = (heroId) => {
  const queryClient = useQueryClient();
  return useQuery(["allTickers", heroId], fetchTickerListData, {
    initialData: () => {
      const data = queryClient
        .getQueryData("allTickers")
        ?.data?.find((data) => data.id === parseInt(heroId));
      if (data) {
        return { data: data };
      } else {
        return undefined;
      }
    },
  });
};